// extracted by mini-css-extract-plugin
export default {"infoText":"EmailQuotaInfo_infoText__zivJ-","infoValue":"EmailQuotaInfo_infoValue__VjUAS"};